// extracted by mini-css-extract-plugin
export default {"otpInput":"forgotpass_otpInput__yakvx"};